import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'lib-loader',
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {}
